import React from "react";
import "./followerBox.scss";

import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";

import { Stack } from "react-bootstrap";
import { t } from "i18next";

const FollowerBox = ({ numberOfFollowers }) => {
  return (
    <div className="follower-box-container px-2 py-1">
      <Stack direction="horizontal" gap={1}>
        <PeopleAltOutlinedIcon />{" "}
        {t("common.followers", { n: numberOfFollowers })}
      </Stack>
    </div>
  );
};

export default FollowerBox;
